import "./product-notes.scss";
import { EventBus, Events, store } from "jiffy-store";

const getMinPriority = () =>
  parseInt(
    document.querySelector("#product-details-variants-form").dataset.minBulkAmountPriority,
    10
  );

const getCartTotal = () =>
  parseFloat(document.querySelector("#product-details-variants-form").dataset.cartTotal);

const initialPriority = () => {
  let originalCartTotal = store.get(state => state.pdp.originalCartTotal);

  if (!originalCartTotal) {
    originalCartTotal = getCartTotal();
    store.pdp.change({ originalCartTotal });
  }

  const minPriority = getMinPriority();
  return minPriority < originalCartTotal ? minPriority : 0;
};

EventBus.on(Events.ORDER_TIER_CHANGED, ({ target }) => {
  document.querySelectorAll(".js-node-discount").forEach(note => {
    note.classList.toggle("hidden", !((target?.tier || initialPriority()) > 0));
  });
});
